import React from 'react'
import Box from '@mui/material/Box'
import { authContext } from '../../../contexts/AuthContext'
import LawyerInformationCard from './LawyerInformationCard'
import { apiUrl } from '../../../config/api'

class LawyerInformation extends React.Component {
  // Pagina para clientes, muestra los abogados asignados en la config del cliente
  constructor() {
    super()

    this.state = {
      client: {},
      list: []
    }
  }

  static contextType = authContext

  componentDidMount() {
    this.fetchClientOrPersonByUser()
  }

  fetchClientOrPersonByUser = () => {
    let url = apiUrl('GetClientOrPersonByUser')
    fetch(`${url}&userId=${this.context.auth.user.id}`)
      .then((response) => response.json())
      .then((data) => {
        this.setState({
          client: data
        })
        this.fetchAssignedUsers(data.id)
      })
  }

  fetchAssignedUsers = (clientId) => {
    let url = apiUrl('ListAssignedLawyersByClient')
    fetch(`${url}&clientId=${clientId}`)
      .then((response) => response.json())
      .then((data) => {
        this.setState({
          list: data
        })
      })
  }

  render() {
    return (
      <Box sx={{ mt: 8, ml: 8 }}>
        {this.state.list.map((lawyer) => (
          <LawyerInformationCard lawyer={lawyer} key={lawyer.id} />
        ))}
      </Box>
    )
  }
}

export default LawyerInformation
